export async function pollUntil<T>(
  fetchFn: () => Promise<T>,
  conditionFn: (data: T) => boolean,
  intervalMs = 2000,
  maxTimeoutMs = 30000,
): Promise<T | null> {
  const startTime = Date.now();

  while (Date.now() - startTime < maxTimeoutMs) {
    try {
      const data = await fetchFn();
      if (conditionFn(data)) {
        return data;
      }
    } catch {
      // Ignore intermediate poll errors
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  return null;
}
